export const mapFacetToOptions = (facet) => {
  if (!facet?.buckets) return [];
  return Object.entries(facet.buckets)
    .filter(([key]) => key && key !== '')
    .map(([key]) => ({
      name: key,
      value: key,
    }));
};